import { getFontSize } from '../../../../constants/fontSizes';

export const bookingSectionStyles = {
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: '#f6f6f6',
    display: 'flex',
    flexDirection: 'column',
  },
  textContainer: {
    width: '100%',
    padding: {xs: '50px 10px 0 10px', lg: '50px 10% 0 10%'},
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '100%',
  },
  heading: {
    fontFamily: 'Aurora',
    fontWeight: 700,
    fontSize: getFontSize(25),
    textTransform: 'capitalize',
    color: 'primary.main',
    lineHeight: '30px',
  },
  title: {
    fontFamily: 'Aurora',
    fontWeight: 700,
    fontSize: getFontSize(80),
    lineHeight: {xs: "45px", md: "60px", lg: "75px", xl: "85px"},
    textTransform: 'capitalize',
    color: 'primary.main',
    marginBottom: '32px',
  },
  subtitle: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(20),
    lineHeight: {xs: "20px", lg: "28px"},
    letterSpacing: '-0.01em',
    textAlign: 'center',
    color: '#252629CC',
    maxWidth: {xs: "100%", lg: "80%"},
  },
  buttonContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '50px',
  },
  fadeInFromTop: (isVisible) => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(-50px)',
    transition: 'opacity 1.2s ease-out, transform 1.2s ease-out',
  }),
};
